import Format from 'helpers/format';
import { getDateFormat, getNow } from 'pages/utils/time';

export const getItemPrintedTimestamp = async () => {
  const dateFormat = await getDateFormat();
  const nowTimestamp = getNow().toString();
  return Format.formatDateTime(nowTimestamp, dateFormat, false);
};
